import { ReactNode } from 'react';
import { ToastTypes } from '../../molecules/toast/Toast';
import DomEventManager from '../../utils/DomEventManager';
import { TFunctionResult } from 'i18next';

export interface NotificationEventData {
    id?: string;
    readonly type: ToastTypes | string;
    readonly heading?: ReactNode | string;
    readonly customButton?: ReactNode;
    readonly message?: ReactNode | string | TFunctionResult;
    readonly sticky?: boolean;
}

export type NotificationsCustomEventType = CustomEvent<NotificationEventData>;
export type EventData = NotificationEventData;

class NotificationsEventManager<EventData> extends DomEventManager<EventData> {
    public notifications: NotificationEventData[];

    protected constructor(event_name: string) {
        super(event_name);

        this.notifications = [];
    }

    public generateRandomId = () => {
        return '_' + Math.random().toString(36).substring(2, 9);
    }

    public static create = <EventData>(event_name: string): NotificationsEventManager<EventData> => {
        return new NotificationsEventManager(event_name);
    }

    public add = (notification: NotificationEventData) => {
        notification.id = this.generateRandomId();
        this.notifications.push(notification);
        this.dispatch(null);
    }

    public close = (id: string) => {
        const index = this.notifications.findIndex(n => n.id === id);

        if(index === -1) {
            return;
        }

        this.notifications.splice(index, 1);
        this.dispatch(null);
    }
}

export default NotificationsEventManager;
